import * as React from 'react';

function CircleInfoIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="1em" height="1em" viewBox="0 0 20 21" fill="none" {...props}>
			<g clipPath="url(#prefix__clip0_28658_49106)">
				<path
					d="M10 20.5a10 10 0 100-20 10 10 0 000 20zm-1.563-6.875h.938v-2.5h-.938a.935.935 0 01-.937-.938c0-.519.418-.937.938-.937h1.874c.52 0 .938.418.938.938v3.437h.313c.519 0 .937.418.937.938 0 .519-.418.937-.938.937H8.438a.935.935 0 01-.938-.938c0-.519.418-.937.938-.937zM10 5.5A1.25 1.25 0 1110 8a1.25 1.25 0 010-2.5z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="prefix__clip0_28658_49106">
					<path
						fill="currentColor"
						transform="translate(0 .5)"
						d="M0 0h20v20H0z"
					/>
				</clipPath>
			</defs>
		</svg>
	);
}

export default CircleInfoIcon;
